//import Libraries
import React from 'react';

//import Components
import Language from '../../../../language/language.json';

//import Style classes
import './Title.css'

const title = (props) => {
    return (
        <div className="ScrollSectionTitle visible">
            <h1>{Language.title.title[props.universal.language]}</h1>
            <p>{Language.title.content[props.universal.language]}</p>
        </div>
    );
}

export default title;


// WEBPACK FOOTER //
// ./src/pages/Home/ScrollSection/Title/Title.js